import axios from 'axios';

let VCA = VCA || {};

VCA.CurrentStories = (function ($) {
    let totalPagesOnLoad = $('#TotalPages').data('total-page');


    function bindEvents() {
        $('.vca-voice-current__option',).on('click', selectFilterOption);
        $('.vca-voice-current__category-option').on('click', selectCategoryOption);
        $('.vca-voice-current__sort-option').on('click', selectFilterOption);
    }

    function setPaginationOnLoad() {
        if ($('.vca-voice-current').length <= 0) {
            return;
        }

        $('#VoiceTotalPagesNum').html(totalPagesOnLoad);

        const urlParams = new URLSearchParams(decodeURIComponent(window.location.search));
        let page = parseInt(urlParams.get("page"));
        if (window.location.href.match(/\?./) && page) {
            let query = `page=${page}`;
            getAPIData(query, page);
        } else {
            createPagination(totalPagesOnLoad, 1);
            $('.pagination-bar__pagination-btn').each(function () {
                $(this).on('click', selectPage);
            });
        }
    }

    function selectPage(e) {
        e.preventDefault();
        let selectedPage = $(e.currentTarget).data('page');
        let activeElements = getActiveSelectOptions(selectedPage);
        let query = '';

        $('#VCAVoiceCurrentStories')[0].scrollIntoView({ behavior: 'smooth' })

        if (activeElements.activeImgVid == '') {
            query = `sortAsc=${activeElements.activeSortOption}&page=${activeElements.activePage}`;
        } 
        else {
            query = `mediaType=${activeElements.activeImgVid}&sortAsc=${activeElements.activeSortOption}&page=${activeElements.activePage}`;
        }

        if(activeElements.activeCategory !== '')
        {
            query = query + `&categories[0]=${activeElements.activeCategory}`;
        }

        getAPIData(query, selectedPage);
    }

    function getAPIData(queryStr, selectedPage) {
        let errMsgContainer = $('.vca-voice-current__error-msg-container');
        let errorMessage = $('.vca-voice-current__error-msg');
        let paginationBar = $('.vca-voice-current__pagination-container');

        createPagination(totalPagesOnLoad, selectedPage);
        $('.pagination-bar__pagination-btn').each(function () {
            $(this).on('click', selectPage);
        });

        $(errMsgContainer).addClass('hidden');

        axios.get('/voice-api/stories?'+ queryStr)
        .then(response => {
            if (response.data.VoiceArticles.length > 0) {
                let totalPages = response.data.TotalPages;
                let data = response.data.VoiceArticles;
                $(paginationBar).removeClass('hidden');
                emptyResultsContainer();
                $('#VoiceTotalPagesNum').html(totalPages);
                createCards(data, totalPages, selectedPage);
            } else {
                emptyResultsContainer();
                $(paginationBar).addClass('hidden');
                $(errorMessage).text('No results were found.')
                $(errMsgContainer).removeClass('hidden');
            }
        })
        .catch(error => {
            console.log('Error message: ', error.response);
        });  
    }

    function getActiveSelectOptions(activePage) {
        let activeCategoryEl = $('.vca-voice-current__category-option.active')[0];
        let activeImgVideoEl = $('.vca-voice-current__option.focused.selected')[0];
        let activeSortOptionEl = $('.vca-voice-current__sort-option.focused.selected')[0];
        let activeCategory = $(activeCategoryEl).attr('id');
        let activeImgVid = $(activeImgVideoEl).data('value');
        let activeSortOption = $(activeSortOptionEl).data('asc');

        if (activeImgVid == undefined) {
            activeImgVid = '';
        }

        if (activePage == undefined) {
            let activePageEl = $('.pagination-bar__pagination-btn.active')[0];
            activePage = $(activePageEl).data('page');
        }

        if(activeCategory === undefined)
        {
            activeCategory = '';
        }
        
        return { activeCategory, activeImgVid, activeSortOption, activePage }
    }

    function selectFilterOption() {
        let activeElements = getActiveSelectOptions();
        // let activePageEl = $('.pagination-bar__pagination-btn.active')[0];
        // let activePage = $(activePageEl).data('page');
        let activePage = 1;
        let query = '';

        if (activeElements.activeImgVid == '') {
            query = `&sortAsc=${activeElements.activeSortOption}&page=${activePage}`;
        } else {
            query = `mediaType=${activeElements.activeImgVid}&sortAsc=${activeElements.activeSortOption}&page=${activePage}`;
        }

        if(activeElements.activeCategory !== '')
        {
            query = query + `&categories[0]=${activeElements.activeCategory}`;
        }

        getAPIData(query, activePage);
    }

    function selectCategoryOption(e) {
        applyActiveCategory(e);
        selectFilterOption();
    }

    function applyActiveCategory(e) {
        let categoryPill = e.currentTarget;
        let pillIsActive = $(categoryPill).hasClass('active');

        if (!pillIsActive) {
            let activePill = $('.vca-voice-current__category-pills').find('.vca-voice-current__category-option.active')[0];
            $(activePill).removeClass('active');
            $(categoryPill).addClass('active');
        } else {
            return;
        }
    }

    function emptyResultsContainer() {
        $('.vca-voice-current__list').empty();
    }

    function createCards(results, totalPages, selectedPage) {

        let articles = results;
        let totalNumOfPages = totalPages;

        let element = document.querySelector("#CurrentStoriesPagination ul");
        let page = selectedPage;
        element.innerHTML = createPagination(totalNumOfPages, page);
        $('.pagination-bar__pagination-btn').each(function () {
            $(this).on('click', selectPage);
        });

        for (let i = 0; i < articles.length; i++) {
            let story = articles[i];
            let storyCard = $(`
                <a href="${story.URL}" class="vca-voice-current__list__item">
                    <div class="vca-voice-current__imgcontainer">
                        <div class="vca-voice-current__list__item__image"><img alt="${story.ImageAlt}"
                                src="${story.ImageUrl}" />
                        </div>
                    </div>
                    <div class="vca-voice-current__info">
                        <span class="vca-voice-current__list__item__caption">${story.Header}</span>
                        <div class="vca-voice-current__list__item__title h4">${story.Title}</div>
                    </div>
                </a>
            `);

            $('.vca-voice-current__list').append(storyCard);
        }
    }

    function createPagination(totalPages, page) {
        let liTag = '';
        let active;
        let beforePage = page - 1;
        let afterPage = page + 1;
        let element = document.querySelector("#CurrentStoriesPagination ul");
        let path = 'vca-voice';

        if (page > 1) {
            liTag += `<li><a href="/${path}?page=${page - 1}" class="pagination-bar__pagination-btn prev-btn prev" data-page="${page - 1}"><span>Prev</span></a></li>`;
        } else if (page == 1) {
            liTag += `<li><a href="/${path}?page=${page}" class="pagination-bar__pagination-btn prev-btn prev disabled" data-page="${page}"><span>Prev</span></a></li>`;
        }

        if(page > 2){ 
            if (totalPages >= 5) {
                liTag += `<li><a href="/${path}?page=1" class="pagination-bar__pagination-btn first numb" data-page="1"><span>1</span></a></li>`;
            }
          if(page > 3 && totalPages > 5){ 
            liTag += `<li class="vca-voice-current__dots dots"><span>...</span></li>`;
          }
        }
        // how many pages or li show before the current li
        if (page == totalPages) {
            beforePage = beforePage - 2;
        } else if (page == totalPages - 1) {
          beforePage = beforePage - 1; 
        }

        if (beforePage < 0) {
            beforePage = 0;
        }
        // how many pages or li show after the current li
        if (page == 1) {
            afterPage = afterPage + 2;
        } else if (page == 2) {
            afterPage = afterPage + 1;
        }
        for (let plength = beforePage; plength <= afterPage; plength++) {
            if (plength > totalPages) { //if plength is greater than totalPage length then continue
                continue;
            }
            if (plength == 0) { //if plength is 0 than add +1 in plength value
                plength = plength + 1;
            }
            if (page == plength) { //if page is equal to plength than assign active string in the active variable
                active = "active";
            } else { //else leave empty to the active variable
                active = "";
            }
            liTag += `<li><a href="/${path}?page=${plength}" class="pagination-bar__pagination-btn numb ${active}"data-page="${plength}"><span>${plength}</span></a></li>`;
        }

        if (page < totalPages - 1) { //if page value is less than totalPage value by -1 then show the last li or page 
          if (page < totalPages - 2 && totalPages > 5) { //if page value is less than totalPage value by -2 then add this (...) before the last li or page 
            liTag += `<li class="vca-voice-current__dots dots"><span>...</span></li>`;
          }
          if (totalPages >= 5) {
            liTag += `<li><a href="/${path}?page=${totalPages}" class="pagination-bar__pagination-btn last numb" data-page="${totalPages}"><span>${totalPages}</span></a></li>`;
          }
        }

        if (page <= totalPages) { //show the next button if the page value is less than totalPage 
            if (page < totalPages) { 
                liTag += `<li><a href="/${path}?page=${page + 1}" class="pagination-bar__pagination-btn next-btn next" data-page="${page + 1}"><span>Next</span></a></li>`;
            } else if (page == totalPages) { 
                liTag += `<li><a href="/${path}?page=${page}" class="pagination-bar__pagination-btn next-btn next disabled" data-page="${page}"><span>Next</span></a></li>`;
            }
        }
        element.innerHTML = liTag; //add li tag inside ul tag
        $('#VoiceCurrentPageNum').text(page)
        return liTag; 
    }

    function init() {
        bindEvents();
        setPaginationOnLoad();
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    VCA.CurrentStories.init();
});

